import { QuestionnaireList } from 'containers';

export const QuestionnaireListPage = () => {
  return (
    <QuestionnaireList />
  );
};

